// extracted by css-extract-rspack-plugin
export default {"container":"container-oWV0Jw"};